import React from 'react';

export default function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="kivo-loader-page">
      <div role="status" aria-live="polite" aria-label={label} className="stack-4" style={{ alignItems: 'center' }}>
        <div className="kivo-loader" aria-hidden="true">
          {Array.from({ length: 12 }).map((_, i) => (
            <span
              key={i}
              className="kivo-loader__spoke"
              style={
                {
                  '--angle': `${i * 30}deg`,
                  '--delay': `${i * 0.08}s`,
                } as React.CSSProperties
              }
            >
              <i className="kivo-loader__dot" />
            </span>
          ))}
        </div>
        <p className="t-small t-mute" style={{ margin: 0 }}>{label}</p>
      </div>
    </div>
  );
}
